/* eslint-disable tailwindcss/no-custom-classname */
import { Summary } from '@/types/summary'
import { Summaries } from '../Summaries'

interface Props {
  recommends: Summary[]
}
export const Recommends: React.FC<Props> = ({ recommends }) => {
  return (
    <>
      <div className="flex mb-[30px] w-full border-t border-[#e6e6e6] border-solid">
        <div className="relative mx-auto mt-[30px] mb-5 min-h-[50px] font-medium text-center">
          <div className="text-2xl leading-6 text-black">
            <span className="text-center shadow-[inset_0_-9px_0_0_#dcecf8]">
              一緒に読まれている要約
            </span>
          </div>
        </div>
      </div>
      <Summaries summaries={recommends} />
    </>
  )
}
